import * as searchShareholder from './shareholders';

export default [
  '$stateProvider',
  function ($stateProvider) {
    const mainState = {
      name: 'agentUserManagement',
      url: '/agent/userManagement',
      params: {
        selectedIndex: 1,
      },
      redirectTo: 'agentUserManagement.agent',
      views: {
        mainView: {
          component: 'agUserManagementMain',
        },
      },
    };

    $stateProvider.state(mainState);

    // Load all the exported state definitions in the './agent', './issuer', etc. files
    [
      searchShareholder,
    ].forEach((states) => {
      Object.values(states).forEach((state) => $stateProvider.state(state));
    });
  },
];
